import { EntryResultEnum } from 'src/ts/enums';
import { EntryResultType } from 'src/ts/interfaces';

const getEntryStatusIcon = (result: EntryResultType) => {
  switch (result) {
    case EntryResultEnum.Clean:
      return 'check';
    case EntryResultEnum.Edited:
      return 'clear';
    case EntryResultEnum.Undetermined:
      return 'warning';
    case EntryResultEnum.Pending:
    default:
      return 'hourglass';
  }
};
export default getEntryStatusIcon;

export const getAttrEntryResult = (result: EntryResultType) => {
  switch (result) {
    case EntryResultEnum.Clean:
      return { icon: 'cardSelectDoc_clean', name: 'Clean' };
    case EntryResultEnum.Edited:
      return { icon: 'cardSelectDoc_edited', name: 'Edited' };
    case EntryResultEnum.Undetermined:
      return { icon: 'cardSelectDoc_insufficient', name: 'Insufficient Documentation' };
    case EntryResultEnum.Pending:
    default:
      return { icon: 'cardSelectDoc_pending', name: 'Pending' };
  }
};
